export type PresetDrawerSize = 'small' | 'medium' | 'large' | 'full';

export const containerHeight = {
  title: 76,
  divider: 1 + 1,
  action: 150,
};

export const drawerSizeLookup: Record<
  PresetDrawerSize,
  `${number}px` | `${number}%`
> = { small: '520px', medium: '851px', large: '1074px', full: '100%' } as const;
